(() => {
  const menuBackground = new Map();
  const syncMobileMenu = (menu) => {
    const root = menu.closest('.mntn-site-header-root');
    const panel = menu.querySelector('.mntn-mobile-menu__panel');
    if (menu.open && root && panel) {
      panel.style.setProperty('--mntn-mobile-menu-top', `${Math.max(0, root.getBoundingClientRect().bottom)}px`);
    }
    const hasOpenMenu = Boolean(document.querySelector('[data-mntn-mobile-menu][open]'));
    document.documentElement.classList.toggle('mntn-mobile-menu-open', hasOpenMenu);
    document.body.classList.toggle('mntn-mobile-menu-open', hasOpenMenu);
    if (hasOpenMenu) {
      document.querySelectorAll('main, .mntn-site-footer').forEach((element) => {
        if (!menuBackground.has(element)) menuBackground.set(element, element.inert);
        element.inert = true;
      });
    } else {
      menuBackground.forEach((wasInert, element) => { element.inert = wasInert; });
      menuBackground.clear();
      if (panel?.contains(document.activeElement)) menu.querySelector('summary')?.focus();
    }
  };

  document.querySelectorAll('[data-mntn-mobile-menu]').forEach((menu) => {
    menu.addEventListener('toggle', () => syncMobileMenu(menu));
  });
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-mntn-mobile-menu][open]').forEach(syncMobileMenu);
  });

  const closeOtherPlayers = (activeCard) => {
    document.querySelectorAll('[data-mntn-release-card]').forEach((card) => {
      if (card === activeCard) return;
      card.querySelector('[data-mntn-player]')?.replaceChildren();
      card.querySelector('[data-mntn-listen]')?.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const listenButton = event.target.closest('[data-mntn-listen]');
    if (listenButton) {
      const card = listenButton.closest('[data-mntn-release-card]');
      const player = card?.querySelector('[data-mntn-player]');
      const url = listenButton.dataset.playerUrl;
      if (!card || !player || !url) return;

      const expanded = listenButton.getAttribute('aria-expanded') === 'true';
      closeOtherPlayers(card);
      if (expanded) {
        player.replaceChildren();
        listenButton.setAttribute('aria-expanded', 'false');
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.loading = 'lazy';
      iframe.title = `${listenButton.dataset.playerPlatform || 'Audio'} player`;
      iframe.allow = 'autoplay *; encrypted-media *; fullscreen *; clipboard-write';
      iframe.setAttribute(
        'sandbox',
        'allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation'
      );
      player.replaceChildren(iframe);
      listenButton.setAttribute('aria-expanded', 'true');
      return;
    }

    const mobileLink = event.target.closest('[data-mntn-mobile-menu] a, .mntn-site-header__cart, .mntn-site-header__logo');
    if (mobileLink) {
      document.querySelectorAll('[data-mntn-mobile-menu][open]').forEach((menu) => { menu.open = false; });
    }
  });

  document.addEventListener('keydown', (event) => {
    const menu = document.querySelector('[data-mntn-mobile-menu][open]');
    if (!menu) return;
    if (event.key === 'Escape') {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    } else if (event.key === 'Tab') {
      const controls = [...menu.closest('header').querySelectorAll('a[href], button, input, select, summary')]
        .filter((element) => element.getClientRects().length && !element.disabled && element.tabIndex >= 0);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
  });

  const zuninStudyNumber = (card) => {
    const match = (card.dataset.title || '').match(/^zunin\s*:\s*study\s*no\.\s*([1-4])$/i);
    return match ? Number(match[1]) : null;
  };

  const sortReleaseGrid = (grid) => {
    const isArchiveGrid = Boolean(grid.closest('[data-mntn-archive-section]'));
    [...grid.querySelectorAll(':scope > [data-mntn-release-card]')]
      .sort((a, b) => {
        if (isArchiveGrid) {
          const aZunin = zuninStudyNumber(a);
          const bZunin = zuninStudyNumber(b);
          if (aZunin !== null && bZunin !== null) return aZunin - bZunin;
          if (aZunin !== null) return -1;
          if (bZunin !== null) return 1;
        }
        return (b.dataset.date || '').localeCompare(a.dataset.date || '');
      })
      .forEach((card) => grid.appendChild(card));
  };

  document
    .querySelectorAll('[data-mntn-release-grid], .mntn-artist-detail .mntn-release-grid')
    .forEach(sortReleaseGrid);

  document.querySelectorAll('[data-mntn-artwork-grid], .mntn-artwork-grid').forEach((grid) => {
    [...grid.querySelectorAll(':scope > .mntn-artwork-card')]
      .sort((a, b) => {
        const aDate = a.dataset.date || a.querySelector('.mntn-artwork-card__year')?.textContent.trim() || '';
        const bDate = b.dataset.date || b.querySelector('.mntn-artwork-card__year')?.textContent.trim() || '';
        return bDate.localeCompare(aDate);
      })
      .forEach((card) => grid.appendChild(card));
  });

  if (document.documentElement.lang.toLowerCase().startsWith('ja')) {
    document.querySelectorAll('.mntn-release-detail__meta time[datetime]').forEach((time) => {
      const match = time.getAttribute('datetime')?.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) time.textContent = `${match[1]}.${match[2]}.${match[3]}`;
    });
  }

  const mobileCatalogue = window.matchMedia('(max-width: 749px)');
  document.querySelectorAll('[data-mntn-progressive-grid]').forEach((grid) => {
    const cards = [...grid.querySelectorAll('[data-mntn-release-card]')];
    const button = grid.parentElement.querySelector('[data-mntn-artist-more]');
    if (!button) return;
    let limit = 6;
    const reveal = () => {
      cards.forEach((card, index) => { card.hidden = mobileCatalogue.matches && index >= limit; });
      button.hidden = !mobileCatalogue.matches || limit >= cards.length;
    };
    button.addEventListener('click', () => {
      const nextCard = cards[limit];
      limit += 6;
      reveal();
      nextCard?.querySelector('a')?.focus();
    });
    mobileCatalogue.addEventListener('change', reveal);
    reveal();
  });

  const musicPage = document.querySelector('[data-mntn-music-page]');
  if (!musicPage) return;

  const catalogue = musicPage.querySelector('[data-mntn-catalogue]');
  const searchInput = musicPage.querySelector('[data-mntn-filter-search]');
  const artistSelect = musicPage.querySelector('[data-mntn-filter-artist]');
  const formatSelect = musicPage.querySelector('[data-mntn-filter-format]');
  const yearSelect = musicPage.querySelector('[data-mntn-filter-year]');
  const statusSelect = musicPage.querySelector('[data-mntn-filter-status]');
  const resetButton = musicPage.querySelector('[data-mntn-filter-reset]');
  const latestSection = musicPage.querySelector('[data-mntn-latest-section]');
  const countOutput = musicPage.querySelector('[data-mntn-release-count]');
  const emptyOutput = musicPage.querySelector('[data-mntn-release-empty]');
  const cards = catalogue ? [...catalogue.querySelectorAll('[data-mntn-release-card]')] : [];
  const catalogueSections = catalogue
    ? [...catalogue.querySelectorAll('[data-mntn-current-section], [data-mntn-archive-section]')]
    : [];
  const revealLimits = new WeakMap();

  const resetRevealLimits = () => {
    catalogueSections.forEach((section) => {
      const button = section.querySelector('[data-mntn-show-more]');
      revealLimits.set(section, Number(button?.dataset.initialLimit || 0));
    });
  };

  if (yearSelect) {
    [...new Set(cards.map((card) => card.dataset.year).filter(Boolean))]
      .sort((a, b) => Number(b) - Number(a))
      .forEach((year) => {
        const option = document.createElement('option');
        option.value = year;
        option.textContent = year;
        yearSelect.appendChild(option);
      });
  }

  const artistParam = new URLSearchParams(window.location.search).get('artist');
  if (artistParam && artistSelect?.querySelector(`option[value="${CSS.escape(artistParam)}"]`)) {
    artistSelect.value = artistParam;
  }

  const applyFilters = () => {
    const search = (searchInput?.value || '').trim().toLowerCase();
    const artist = artistSelect?.value || '';
    const format = formatSelect?.value || '';
    const year = yearSelect?.value || '';
    const status = statusSelect?.value || '';
    const active = Boolean(search || artist || format || year || status);
    let count = 0;

    if (latestSection) latestSection.hidden = active;

    catalogueSections.forEach((section) => {
      const sectionCards = [...section.querySelectorAll('[data-mntn-release-card]')];
      const matchingCards = sectionCards.filter((card) => {
        const searchable = `${card.dataset.title || ''} ${card.textContent || ''}`.toLowerCase();
        return (
          (!search || searchable.includes(search)) &&
          (!artist || card.dataset.artist === artist) &&
          (!format || card.dataset.format === format) &&
          (!year || card.dataset.year === year) &&
          (!status || card.dataset.status === status) &&
          !(!active && card.dataset.isLatest === 'true')
        );
      });
      const button = section.querySelector('[data-mntn-show-more]');
      const initialLimit = Number(button?.dataset.initialLimit || matchingCards.length);
      const limit = mobileCatalogue.matches
        ? revealLimits.get(section) || initialLimit
        : matchingCards.length;

      sectionCards.forEach((card) => {
        card.hidden = true;
      });
      matchingCards.forEach((card, index) => {
        card.hidden = index >= limit;
      });

      count += matchingCards.length;
      section.hidden = matchingCards.length === 0;
      if (button) {
        button.hidden = !mobileCatalogue.matches || matchingCards.length <= limit;
        button.setAttribute('aria-expanded', String(matchingCards.length <= limit));
      }
    });

    if (countOutput) {
      const countOne = musicPage.dataset.countOne || '1 release';
      const countMany = musicPage.dataset.countMany || '[count] releases';
      countOutput.textContent = count === 1 ? countOne : countMany.replace('[count]', String(count));
    }
    if (emptyOutput) emptyOutput.hidden = count !== 0;
  };

  catalogue?.querySelectorAll('[data-mntn-show-more]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('[data-mntn-current-section], [data-mntn-archive-section]');
      if (!section) return;
      const initialLimit = Number(button.dataset.initialLimit || 0);
      const step = Number(button.dataset.step || initialLimit);
      const previousVisible = new Set([...section.querySelectorAll('[data-mntn-release-card]')].filter((card) => !card.hidden));
      revealLimits.set(section, (revealLimits.get(section) || initialLimit) + step);
      applyFilters();
      const nextCard = [...section.querySelectorAll('[data-mntn-release-card]')].find((card) => !card.hidden && !previousVisible.has(card));
      nextCard?.querySelector('a')?.focus();
    });
  });

  [searchInput, artistSelect, formatSelect, yearSelect, statusSelect].forEach((control) => {
    control?.addEventListener(control.tagName === 'INPUT' ? 'input' : 'change', () => {
      resetRevealLimits();
      applyFilters();
    });
  });

  resetButton?.addEventListener('click', () => {
    if (searchInput) searchInput.value = '';
    [artistSelect, formatSelect, yearSelect, statusSelect].forEach((control) => {
      if (control) control.value = '';
    });
    resetRevealLimits();
    applyFilters();
  });

  const handleCatalogueViewportChange = () => {
    resetRevealLimits();
    applyFilters();
  };
  if (mobileCatalogue.addEventListener) {
    mobileCatalogue.addEventListener('change', handleCatalogueViewportChange);
  } else {
    mobileCatalogue.addListener(handleCatalogueViewportChange);
  }

  resetRevealLimits();
  applyFilters();
})();
